"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const isValid = (props) => props.valid &&
    !props.error &&
    !(0, lodash_1.default)(props.fields)
        .values()
        .some((field) => field.error && field.touched);
exports.default = isValid;
